import { Component } from '@angular/core';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  standalone: true,
  styleUrl: './no-access.component.css',

})
export class NoAccessComponent {}
